<template>
    <grid-item
        :x="widget.x"
        :y="widget.y"
        :w="widget.w"
        :h="widget.h"
        :i="widget.i"
        :min-h="3"
        :max-h="5"
        :min-w="1"
        :max-w="3"
        :drag-allow-from="dragHandle"
        :drag-option="{ autoScroll: true }"
        :resize-option="{
            autoScroll: true,
            edges: { top: false, left: true, bottom: true, right: true },
            listeners: {
                end: () => triggerSizeChange(widget.i, widget.h, widget.w, true),
            },
        }"
        :resize-ignore-from="'.vrm-widget__header'"
        v-on="$listeners"
        @resized="triggerSizeChange"
        @move="onDragStart"
        @moved="onDragEnd"
    >
        <vrm-widget
            :widget="widget"
            :has-touch-enabled="hasTouchEnabled"
            :installation="installation"
            :graph-data="graphData"
            :custom-graph-data="customGraphData"
            :loading="loading"
            :range="range"
            :is-mobile="isMobile"
            :zoomstate="zoomstate"
            :persistent-mode="persistentMode"
            v-on="$listeners"
        ></vrm-widget>
    </grid-item>
</template>

<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { GridItem } from 'vue-grid-layout';
import VrmWidget from '@/vue/components/shared/grid/VrmWidget.vue';

@Component({
    components: {
        GridItem,
        VrmWidget,
    },
})
export default class VrmWidgetGridItem extends Vue {
    @Prop({ type: Object, default: () => {} })
    widget;
    @Prop({ type: Boolean, default: false })
    isMobile;
    @Prop({ type: Object, default: null })
    range;
    @Prop({ type: Object, default: null })
    zoomstate;
    @Prop({ type: Object, default: null })
    installation;
    @Prop({ type: Object, default: () => {} })
    graphData;
    @Prop({ type: Object, default: () => {} })
    customGraphData;
    @Prop({ type: Boolean, default: false })
    loading;
    @Prop({ type: Boolean, default: false })
    hasTouchEnabled;
    @Prop({ type: Boolean, default: false })
    persistentMode;

    @Watch('widgetActive')
    onWidgetActiveChange(newValue) {
        if (newValue === false) {
            this.$emit('widget-disable', this.widget.uniqueIdentifier);
        }
    }

    get widgetActive() {
        return this.widget.gridItemState.active;
    }

    /**
     * Called when a user starts dragging a widget.
     *
     * Sets [this.dragging] true to prevent the skeleton from being shown while dragging.
     *
     * @param i
     * @param x
     * @param y
     */
    // eslint-disable-next-line no-unused-vars
    onDragStart(i, x, y) {
        this.dragging = true;
    }

    /**
     * Called when the user stops dragging a widget.
     *
     * Resets [this.dragging] so the skeleton is shown again when a widget leaves the viewport.
     *
     * @param i
     * @param h
     * @param w
     */
    onDragEnd(i, h, w) {
        this.dragging = false;
        this.triggerSizeChange(i, h, w);
    }

    triggerSizeChange(i, newH, newW, nextTick = false) {
        const newSize = `${newW}x${newH}-resized`;
        if (nextTick !== true) {
            this.widget.size = newSize;
            return;
        }
        this.$nextTick(() => {
            this.widget.size = newSize;
        });
    }

    get dragHandle() {
        return this.hasTouchEnabled ? '.vrm-drag-handle' : '.vrm-widget__header';
    }
}
</script>
